var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIButton',{attrs:{"href":_vm.feedbackLink}},[_vm._v(" "+_vm._s(_vm.$t('bi.header.feedback'))+" "),_c('UIIcon',{attrs:{"type":"mail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }